import React, { useEffect } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { initializeMetaPixel } from './lib/metaPixel';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { BluOceanSection } from './components/BluOceanSection';
import { WhyBookUs } from './components/WhyBookUs';
import { Gallery } from './components/Gallery';
import { Packages } from './components/Packages';
import { ClientRatings } from './components/ClientRatings';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyButtons } from './components/StickyButtons';
export function App() {
  useEffect(() => {
    initializeMetaPixel();
  }, []);
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-sand-light font-sans text-gray-800 overflow-x-hidden" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <BluOceanSection data-id="element-5" />
          <WhyBookUs data-id="element-6" />
          <Gallery data-id="element-7" />
          <Packages data-id="element-8" />
          <ClientRatings data-id="element-9" />
          <Reviews data-id="element-10" />
          <Faq data-id="element-11" />
          <FinalCTA data-id="element-12" />
        </main>
        <Footer data-id="element-13" />
        <StickyButtons data-id="element-14" />
      </div>
    </LanguageProvider>;
}